<section class="edp-unavailability">
    <div *ngIf="!!data" class="container">
        <img [src]="data.image" alt="unavailability">
        <h1>{{data.title}}</h1>
        <p>{{data.textOne}}</p>
        <p>{{data.textTwo}}</p>
        <a *ngIf="!!data.forwardingCTA" [edpExternalLink]="data.forwardingCTA" [href]="data.forwardingCTA">
            <button class="btn btn-primary">{{data.textCta}}</button>
        </a>
    </div>
</section>
